module.exports = __webpack_public_path__ + "static/media/sugar.0cde6e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sugar.png
// module id = 991
// module chunks = 4